/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppointmentConfirmation = function () {
  function AppointmentConfirmation() {
    _classCallCheck(this, AppointmentConfirmation);
    this.emailString = document.querySelector('#appointment-confirmation-form-user-email');
    this.conditionText = document.querySelector('#condition-text');
  }
  return _createClass(AppointmentConfirmation, [{
    key: "setFindCareCategory",
    value: function setFindCareCategory() {
      var recentCondition = sessionStorage.getItem('recent-condition');
      this.conditionText.innerHTML = recentCondition;
    }
  }, {
    key: "setUserEmail",
    value: function setUserEmail() {
      var email = sessionStorage.getItem('email');
      if (email) {
        this.emailString.innerHTML = "".concat(email, ".");
      }
    }
  }]);
}();
export { AppointmentConfirmation as default };
(function () {
  var isAptConfirmationPage = document.querySelectorAll('.appointment-confirmation')[0];
  if (isAptConfirmationPage) {
    var appointmentConfirmation = new AppointmentConfirmation();
    appointmentConfirmation.setUserEmail();
    appointmentConfirmation.setFindCareCategory();
  }
})(Drupal);